import { useState } from "react";
import JSLayout from "./js_layout";

const messagesCss = `
  .msg-layout { display:grid; grid-template-columns:300px 1fr; gap:0; height:calc(100vh - 130px); background:#fff; border:1px solid rgba(var(--color-text-rgb),0.07); border-radius:4px; overflow:hidden; }
  .msg-list { border-right:1px solid rgba(var(--color-text-rgb),0.07); overflow-y:auto; }
  .msg-list-hdr { padding:1.1rem 1.25rem; border-bottom:1px solid rgba(var(--color-text-rgb),0.07); font-family: 'DM Sans', sans-serif; font-size:1rem; font-weight:600; color:var(--color-text); }
  .msg-list-hdr em { font-style:normal; }
  .msg-item { padding:1rem 1.25rem; border-bottom:1px solid rgba(var(--color-text-rgb),0.05); cursor:pointer; transition:background 0.15s; display:flex; gap:0.75rem; }
  .msg-item:hover { background:#faf8f5; }
  .msg-item.active { background:var(--color-bg-subtle); }
  .msg-item-av { width:38px; height:38px; border-radius:50%; background:var(--color-text); display:flex; align-items:center; justify-content:center; font-family: 'DM Sans', sans-serif; font-size:0.9rem; font-weight:600; color:var(--color-primary); flex-shrink:0; }
  .msg-item-body { flex:1; min-width:0; }
  .msg-item-top { display:flex; justify-content:space-between; align-items:baseline; margin-bottom:2px; }
  .msg-item-name { font-size:0.84rem; font-weight:500; color:var(--color-text); }
  .msg-item-time { font-size:0.65rem; color:#bbb; flex-shrink:0; }
  .msg-item-preview { font-size:0.75rem; color:#aaa; font-weight:300; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .msg-item-preview.unread { color:#555; font-weight:400; }
  .msg-unread-dot { width:7px; height:7px; border-radius:50%; background:var(--color-primary); flex-shrink:0; margin-top:6px; }
  .msg-thread { display:flex; flex-direction:column; overflow:hidden; }
  .msg-thread-hdr { padding:1.1rem 1.5rem; border-bottom:1px solid rgba(var(--color-text-rgb),0.07); display:flex; align-items:center; gap:0.75rem; }
  .msg-thread-av { width:36px; height:36px; border-radius:50%; background:var(--color-text); display:flex; align-items:center; justify-content:center; font-family: 'DM Sans', sans-serif; font-size:0.85rem; font-weight:600; color:var(--color-primary); }
  .msg-thread-name { font-size:0.9rem; font-weight:500; color:var(--color-text); }
  .msg-thread-role { font-size:0.72rem; color:#aaa; font-weight:300; }
  .msg-thread-body { flex:1; overflow-y:auto; padding:1.25rem 1.5rem; display:flex; flex-direction:column; gap:1rem; }
  .msg-bubble { max-width:72%; }
  .msg-bubble.mine { align-self:flex-end; }
  .msg-bubble.theirs { align-self:flex-start; }
  .msg-bubble-text { padding:0.75rem 1rem; border-radius:4px; font-size:0.84rem; line-height:1.6; }
  .msg-bubble.mine .msg-bubble-text { background:var(--color-text); color:var(--color-bg-subtle); border-radius:4px 4px 0 4px; }
  .msg-bubble.theirs .msg-bubble-text { background:var(--color-bg-subtle); color:var(--color-text); border-radius:4px 4px 4px 0; }
  .msg-bubble-time { font-size:0.62rem; color:#bbb; margin-top:3px; }
  .msg-bubble.mine .msg-bubble-time { text-align:right; }
  .msg-compose { padding:1rem 1.5rem; border-top:1px solid rgba(var(--color-text-rgb),0.07); display:flex; gap:0.75rem; }
  .msg-compose-input { flex:1; padding:0.75rem 1rem; background:var(--color-bg-subtle); border:1px solid rgba(var(--color-text-rgb),0.1); border-radius:2px; font-family:'DM Sans',sans-serif; font-size:0.85rem; font-weight:300; color:var(--color-text); outline:none; resize:none; transition:border-color 0.2s; }
  .msg-compose-input:focus { border-color:var(--color-primary); }
  .msg-send-btn { background:var(--color-text); color:var(--color-bg-subtle); padding:0.75rem 1.25rem; border:none; border-radius:2px; font-family:'DM Sans',sans-serif; font-size:0.72rem; font-weight:500; letter-spacing:0.08em; text-transform:uppercase; cursor:pointer; transition:background 0.2s; flex-shrink:0; }
  .msg-send-btn:hover { background:var(--color-primary); color:var(--color-text); }
  .msg-empty { flex:1; display:flex; align-items:center; justify-content:center; flex-direction:column; gap:0.75rem; color:#bbb; }
  .msg-empty-icon { font-size:2rem; }
  .msg-empty-text { font-size:0.85rem; font-weight:300; }
  @media(max-width:768px){
    .msg-layout { grid-template-columns:1fr; height:auto; }
    .msg-thread { display:none; }
    .msg-layout.thread-open .msg-list { display:none; }
    .msg-layout.thread-open .msg-thread { display:flex; height:calc(100vh - 140px); }
  }
`;

const CONVOS = [
  { id:1, initials:"LH", name:"Luxe Hair Studio", role:"Employer", preview:"Looking forward to your interview on the 28th!", time:"10:32 AM", unread:true,
    messages:[
      { mine:false, text:"Hi Amara! We reviewed your application and we love your portfolio. Would you be available for an interview?", time:"Yesterday 3:14 PM" },
      { mine:true,  text:"Thank you so much! Yes, I'm very interested. I'm available most of next week.", time:"Yesterday 3:45 PM" },
      { mine:false, text:"Great! How about Thursday the 28th at 10:00 AM on Google Meet?", time:"Yesterday 4:02 PM" },
      { mine:true,  text:"That works perfectly for me. I'll be there!", time:"Yesterday 4:10 PM" },
      { mine:false, text:"Looking forward to your interview on the 28th!", time:"10:32 AM" },
    ]
  },
  { id:2, initials:"EA", name:"Elite Beauty Academy", role:"Employer", preview:"We'd love to schedule a call to discuss the role", time:"Yesterday", unread:true,
    messages:[
      { mine:false, text:"Hello Amara, we came across your profile and think you'd be a wonderful fit for our Beauty Educator position.", time:"Yesterday 9:00 AM" },
      { mine:false, text:"We'd love to schedule a call to discuss the role further. Are you available this week?", time:"Yesterday 9:01 AM" },
    ]
  },
  { id:3, initials:"ZW", name:"Zen Wellness Spa", role:"Employer", preview:"Thank you for applying to our spa therapist role", time:"Mar 15", unread:false,
    messages:[
      { mine:false, text:"Thank you for applying to our spa therapist role. We'll review your profile and be in touch shortly.", time:"Mar 15 11:00 AM" },
    ]
  },
];

export function Messages() {
  const [active, setActive] = useState(1);
  const [text, setText] = useState("");
  const [convos, setConvos] = useState(CONVOS);
  const [mobileThread, setMobileThread] = useState(false);

  if (typeof document !== "undefined" && !document.getElementById("bl-msg-css")) {
    const s = document.createElement("style"); s.id="bl-msg-css"; s.textContent=messagesCss; document.head.appendChild(s);
  }

  const activeConvo = convos.find(c => c.id === active);
  const sendMessage = () => {
    if (!text.trim()) return;
    setConvos(prev => prev.map(c => c.id === active ? { ...c, messages:[...c.messages, { mine:true, text, time:"Just now" }], preview:text, unread:false } : c));
    setText("");
  };

  return (
    <JSLayout title="My" titleEm="Messages">
      <div className={`msg-layout${mobileThread ? " thread-open" : ""}`}>
        {/* conversation list */}
        <div className="msg-list">
          <div className="msg-list-hdr">Messages <em>({convos.filter(c=>c.unread).length} unread)</em></div>
          {convos.map(c => (
            <div key={c.id} className={`msg-item${active === c.id ? " active" : ""}`}
              onClick={() => { setActive(c.id); setMobileThread(true); setConvos(prev => prev.map(x => x.id === c.id ? { ...x, unread:false } : x)); }}>
              <div className="msg-item-av">{c.initials}</div>
              <div className="msg-item-body">
                <div className="msg-item-top">
                  <div className="msg-item-name">{c.name}</div>
                  <div className="msg-item-time">{c.time}</div>
                </div>
                <div className={`msg-item-preview${c.unread ? " unread" : ""}`}>{c.preview}</div>
              </div>
              {c.unread && <div className="msg-unread-dot" />}
            </div>
          ))}
        </div>

        {/* thread */}
        <div className="msg-thread">
          {activeConvo ? (
            <>
              <div className="msg-thread-hdr">
                <button onClick={() => setMobileThread(false)} style={{ background:"none",border:"none",cursor:"pointer",color:"#aaa",fontSize:"1rem",padding:"0",marginRight:"0.25rem",display:"none" }} className="msg-back">←</button>
                <div className="msg-thread-av">{activeConvo.initials}</div>
                <div>
                  <div className="msg-thread-name">{activeConvo.name}</div>
                  <div className="msg-thread-role">{activeConvo.role}</div>
                </div>
              </div>
              <div className="msg-thread-body">
                {activeConvo.messages.map((m,i) => (
                  <div key={i} className={`msg-bubble ${m.mine ? "mine" : "theirs"}`}>
                    <div className="msg-bubble-text">{m.text}</div>
                    <div className="msg-bubble-time">{m.time}</div>
                  </div>
                ))}
              </div>
              <div className="msg-compose">
                <textarea className="msg-compose-input" rows={1} placeholder="Type a message…" value={text} onChange={e => setText(e.target.value)}
                  onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(); } }} />
                <button className="msg-send-btn" onClick={sendMessage}>Send</button>
              </div>
            </>
          ) : (
            <div className="msg-empty">
              <div className="msg-empty-icon">✉</div>
              <div className="msg-empty-text">Select a conversation</div>
            </div>
          )}
        </div>
      </div>
    </JSLayout>
  );
}